import React, { useEffect, useState } from 'react';
import { validateFunctionalForm } from '../../utils';
import { v2_ships } from '../../actions/v2/projectAndVessel';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { v3_upload_document } from '../../actions/v3/document';
import { v2_categories } from '../../actions/v2/masterData';
import constant from '../../constant';

const Form = ({ data, onSubmit, projectId }) => {
    const [state, setState] = useState({
        ships: { name: 'ships', value: '', options: [], isRequired: true, error: '' },
        categoryId: { name: 'categoryId', value: '', options: [], isRequired: true, error: '' },
        subject: { name: 'subject', value: '', isRequired: true, error: '' },
        note: { name: 'note', value: '', isRequired: false, error: '' },
        documentFiles: { name: 'documentFiles', value: [{ fileName: '', originalFileName: '' }], isRequired: true, error: '' },
    });

    useEffect(() => {
        v2_ships(null, projectId).then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ships: {
                        ...prev.ships,
                        options: res.result
                    }
                }));
            }
        });
    }, [projectId]);

    useEffect(() => {
        v2_categories().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    categoryId: {
                        ...prev.categoryId,
                        options: res.result
                    }
                }));
            }
        });
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value,
                error: prev[name].isRequired && !value ? 'This field is required' : ''
            }
        }));
    };

    const handleFileChange = (index, file) => {
        const formData = new FormData();
        formData.append('file', file);

        v3_upload_document(formData).then((res) => {
            if (res.status && res.result) {
                const updatedFiles = [...state.documentFiles.value];
                updatedFiles[index] = {
                    fileName: res.result.fileName,
                    originalFileName: res.result.originalFileName
                };

                setState(prev => ({
                    ...prev,
                    documentFiles: {
                        ...prev.documentFiles,
                        value: updatedFiles,
                        error: updatedFiles.length === 0 ? 'This field is required' : ''
                    }
                }));
            }
        });
    };

    const addFileField = () => {
        setState(prev => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: [...prev.documentFiles.value, { fileName: '', originalFileName: '' }],
                error: ''
            }
        }));
    };

    const removeFileField = (index) => {
        const updatedFiles = state.documentFiles.value.filter((_, i) => i !== index);
        setState(prev => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: updatedFiles,
                error: updatedFiles.length === 0 ? 'At least one document is required' : ''
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {
                projectId: projectId,
                shipId: state.ships.value,
                categoryId: state.categoryId.value,
                subject: state.subject.value,
                description: state.note.value,
                files: state.documentFiles.value, // actual files
            };
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };

    const handleReset = () => {
        const resetState = { ...state };
        Object.keys(resetState).forEach(key => {
            resetState[key].value = key === 'documentFiles' ? [{ file: null }] : '';
            resetState[key].error = '';
        });
        setState(resetState);
    };

    return (
        <React.Fragment>
           
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-4 mb-3">
                        <label>Hull Number {state.ships.isRequired && <span className='text-danger'> *</span>}</label>
                        <select
                            name={state.ships.name}
                            value={state.ships.value}
                            onChange={handleChange}
                            className={`form-control ${state.ships.error ? 'is-invalid' : ''}`}
                        >
                            <option value="">Select Hull Number</option>
                            {state.ships.options.map((ship) => (
                                <option key={ship.ID} value={ship.ID}>
                                    {ship.HULL_NUMBER} - {ship.SHIP_NAME}
                                </option>
                            ))}
                        </select>
                        {state.ships.error && <div className="invalid-feedback">{state.ships.error}</div>}
                    </div>

                    <div className="col-md-4 mb-3">
                        <label>Category {state.categoryId.isRequired && <span className='text-danger'> *</span>}</label>
                        <select
                            name={state.categoryId.name}
                            value={state.categoryId.value}
                            onChange={handleChange}
                            className={`form-control ${state.categoryId.error ? 'is-invalid' : ''}`}
                        >
                            <option value="">Select Category</option>
                            {state.categoryId.options.map((item) => (
                                <option key={item.ID} value={item.ID}>
                                    {item.CATEGORY_NAME}
                                </option>
                            ))}
                        </select>
                        {state.categoryId.error && <div className="invalid-feedback">{state.categoryId.error}</div>}
                    </div>

                    <div className="col-md-4 mb-3">
                        <label>Subject {state.subject.isRequired && <span className='text-danger'> *</span>}</label>
                        <input
                            type="text"
                            name={state.subject.name}
                            value={state.subject.value}
                            onChange={handleChange}
                            className={`form-control ${state.subject.error ? 'is-invalid' : ''}`}
                            placeholder="Enter Subject / Issue"
                        />
                        {state.subject.error && <div className="invalid-feedback">{state.subject.error}</div>}
                    </div>

                    <div className="col-md-12 mb-3">
                        <label>Upload Documents </label>

                        {state.documentFiles.value.map((item, index) => (
                            <div key={index} className="d-flex align-items-center mb-2">
                                {item.fileName ? (
                                    <>
                                        <div className="me-2 flex-grow-1">
                                            <span>{item.originalFileName}</span>
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger"
                                            onClick={() => removeFileField(index)}
                                        >
                                            <FaTrash />
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <input
                                            type="file"
                                            onChange={(e) => handleFileChange(index, e.target.files[0])}
                                            className="form-control me-2"
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger"
                                            onClick={() => removeFileField(index)}
                                        >
                                            <FaTrash />
                                        </button>
                                    </>
                                )}
                            </div>
                        ))}

                        {/* Add button always visible below the list */}
                        <div>
                            <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={addFileField}
                            >
                                <FaPlus className="me-1" /> Add Document
                            </button>
                        </div>

                        {state.documentFiles.error && (
                            <div className="text-danger mt-1">{state.documentFiles.error}</div>
                        )}
                    </div>



                    <div className="col-md-12 mb-3">
                        <label>Note</label>
                        <textarea
                            name={state.note.name}
                            value={state.note.value}
                            onChange={handleChange}
                            className="form-control"
                            rows="2"
                            placeholder="Any additional notes (optional)"
                        />
                    </div>
                </div>

                <div className="mt-3">
                    <button type="submit" className="btn btn-success me-2">Submit</button>
                    <a className="btn btn-danger text-white" href={constant.Authedcomponent.listProject.url}>Cancel</a>
                </div>
            </form>

        </React.Fragment>

    );
};

export default Form;
